<template>
  <div
    class="drop-item _pb-12 _pb-sm-8"
    :class="{ 'drop-item_opened': opened }"
  >
    <div class="d-xl-flex align-start d-block">
      <div class="d-flex justify-between align-start drop-item_container">
        <div>
          <div
            class="_fs-30 _fs-sm-24 _lh-sm-32 _lh-42 _fw-400 _tc-dark"
            v-html="item.title"
          ></div>
        </div>

        <div @click="open" class="drop-item__opener _pa-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 5V19M12 19L19 12M12 19L5 12"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
    <div v-if="opened" class="_mt-12">
      <div class="drop-item_layout container">
        <div class="drop-item_col-1">
          <DropElement
            v-for="(children, i) in item.childrens.first_col"
            :key="i"
            :item="children"
          ></DropElement>
        </div>
        <div class="drop-item_col-2">
          <DropElement
            v-for="(children, i) in item.childrens.second_col"
            :key="i"
            :item="children"
          ></DropElement>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropElement from '@/components/UI/DropElement.vue'
export default {
  components: { DropElement },
  name: 'DropItem',
  props: {
    item: Object,
  },
  data: () => ({ opened: false }),
  methods: {
    open() {
      if (!this.opened) {
        if (this.$gtm) {
          this.$gtm.push({
            event: 'resources_more',
            param_value: this.helpers.stripHtml(this.item.title),
          })
        }
      }
      this.opened = !this.opened
    },
  },
}
</script>

<style lang="scss" scoped>
.drop-item {
  margin-bottom: 48px;
  &_container {
    width: 100%;
  }
  &_layout {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    @media screen and (max-width: 767px) {
      flex-direction: column;
      gap: 16px;
    }
  }
  &_col-1,
  &_col-2 {
    width: 100%;
    max-width: 592px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media screen and (max-width: 1220px) {
      max-width: none;
    }
  }
  &:last-child {
    margin-block: 0;
  }

  &:hover {
    .drop-item__description {
      color: color(green-second) !important;
    }
  }

  @media screen and (max-width: 743px) {
    margin-bottom: 32px;
  }

  &__description {
    transition: 0.3s;
    width: fit-content;
  }

  &__icon {
    & img {
      width: 141px;
    }
  }
  border-bottom: 1px solid #b2b4b2;
  &_opened {
    .drop-item__opener > svg {
      transform: rotate(180deg);
    }
  }
  &__image-container {
    width: 488px;
    height: 500px;
    border-radius: 24px;
    overflow: hidden;
    flex-shrink: 0;

    @media screen and (max-width: 1220px) {
      width: 100%;
      margin-top: 32px;
    }

    @media screen and (max-width: 743px) {
      height: 300px;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &__opener {
    margin-left: 66px;
    flex-shrink: 0;
    border-radius: 16px;
    background-color: #707372;
    cursor: pointer;
    transition: 0.3s;

    & > svg {
      transition: 0.3s;
    }

    &:hover {
      background-color: #b2b4b2;
    }

    @media screen and (max-width: 743px) {
      margin-left: 24px;
    }
  }
}
</style>

<style lang="scss">
.drop-item {
  & ul {
    list-style-type: disc;
  }
}
</style>
